/* Utilitiy functions that don't need to use 'this' keyword are to be placed here */
import { allSubjectsInOrder, apisDataCacheKeys, cbseScienceGrade, commonWebsite, courseTypes, irregularExamtypes, neetNewVerTypes, subjectDisplayNames, testSpanFormat, testTypeValues, Admin, ISDCodes } from '@app-constants/app.constants';
import {environment} from '@app-environments/environment';
import * as moment from 'moment';
import { UserService } from '@app-services/user/user.service';

export function navigateBetweenProjects(router: any, route: any, routerActive?:any) {

  let isFromSharebleLink : boolean;
  isFromSharebleLink = (routerActive?.queryParams?.isFromShareLink == 'true') ?  true : false;
  localStorage.setItem('isFromShareLink', routerActive?.queryParams?.isFromShareLink)
  if(isFromSharebleLink == true){
    localStorage.setItem('ruleIdFromShare', atob(routerActive.queryParams?.ruleId))
  }
  if(route && route[0] && route[0] != '/') {
    route = '/'+route;
  }
  handleNavigationFromDifferentExternalApps(router ,routerActive);
  if(commonWebsite) {
    router.navigateByUrl(route)
  } else {
    location.href = location.origin + route;
  }
}
function handleNavigationFromDifferentExternalApps(router: any ,routerActive?:any){
  let isFromExternalApp : boolean;
  isFromExternalApp = (routerActive?.queryParams?.isFromExternalApp == 'true') ?  true : false;
  if(isFromExternalApp) {
      localStorage.setItem('isFromExternalApp',routerActive?.queryParams?.isFromExternalApp);
      localStorage.setItem('pageName', routerActive?.queryParams?.pageName);
  }
}

export function parseTestSubjects(examInfo: any) {
  const subjectData = examInfo.subjectsdata;
  const courseType : any = getCourseName(Array.isArray(examInfo.coursetype) ? examInfo.coursetype[0] :  examInfo.coursetype|| "");
  const isNeet = filterCMSData()?.[0]?.CMS_Exam_Name ==  "NEET"? true :false;
  //['51592ef8-8334-479f-8a91-7cfe809b7c04','5d6fcff0-1000-45bb-b62a-d3d2b2bd3189'].some(v=>v == examInfo?.test_type)//(courseType || "").replaceAll(" ", "").toUpperCase() == 'NEET';
  const isNTSE = (courseType || "").replaceAll(" ", "").toUpperCase() == 'NTSE';
  const isNeetNewType = (courseType || "").replaceAll(" ", "").toUpperCase() == 'NEET' && neetNewVerTypes.indexOf(examInfo.examtype || "") > -1;
  const subjectsByName = {};
  
  for(let i = 0, len = subjectData.length; i < len; i++) {
    const so = subjectData[i];
    const subjectName = (so.subjectname || "").replaceAll(" ", "").toUpperCase();
    let subName = subjectName, subIndex;
    if(/^CHEMISTRY/i.test(subjectName)){
      subName = isNTSE ? 'SCIENCE' : 'CHEMISTRY';
    } else if(/^PHYSICS/i.test(subjectName)){
      subName = isNTSE ? 'SCIENCE' : 'PHYSICS';
    } else {
      if(/^MATHEMATICS/i.test(subjectName) || /^MATHS/i.test(subjectName)){
        subName = 'MATHEMATICS'
      } else if(/^MAT\s+/i.test(so.subjectname)){
        //For MAT, compare regEx with original subject name to avoid conflicts with variants of Maths name
        subName = 'MAT'
      } else if(/^BIOLOGY/i.test(subjectName)){
        subName = isNTSE ? 'SCIENCE' :'BIOLOGY';
      } else if(/^BRAINTEASERS/i.test(subjectName)){
        subName = 'BRAINTEASERS';
      } else if (/Quantitative/i.test(subjectName)) {
        subName = 'QUANTITATIVEREASONING';
      } else if (/Spatial/i.test(subjectName)) {
        subName = 'SPATIALREASONING';
      } else if (/Verbal/i.test(subjectName)) {
        subName = 'VERBALREASONING';
      } else if (/English/i.test(subjectName)) {
        subName = 'ENGLISH';
      } else if (/Science/i.test(subjectName)) {
        subName = 'SCIENCE';
      }else if (/Social/i.test(subjectName)) {
        subName = 'SOCIALSTUDIES';
      }else if (/MENTALABILITY/i.test(subjectName)) {
        subName = 'MENTALABILITY';
      } 
      else {
        if(/^BOTANY/i.test(subjectName)){
          subName = 'BOTANY'
        } else if(/^ZOOLOGY/i.test(subjectName)) {
          subName = 'ZOOLOGY'
        }
        // if(irregularExamtypes.indexOf(examInfo.examtype) < 0) {
        //   if(isNeetNewType) {
        //     if(!examInfo.sectionExists) {
        //       subName = 'BIOLOGY';
        //     }
        //   }
          if(isNeet && examInfo?.consolidateSubject) {
            if((/^BOTANY/i.test(subjectName) || /^ZOOLOGY/i.test(subjectName) )){
              subName = 'BIOLOGY'
            }
            // if((/^BOTANY/i.test(subjectName) || /^ZOOLOGY/i.test(subjectName) ) && (examInfo.examtype == 'ASSIGNMENTS' || examInfo.examtype == 'CHAPTERTESTS')){
          }
        // }  
      }
    }
    subjectsByName[subName] = {name: subName, displayedName: subjectDisplayNames[subName] };
  }
  // const subjects = [];
  // let i = 0;
  // allSubjectsInOrder.forEach(subName => {
  //   const obj = subjectsByName[subName];
  //   if(obj) {
  //     obj.position = i++;
  //     subjects.push(obj);
  //   }
  // });
  // return { subjects, subjectsByName }; // uncomment if needed with wrong leftside subjects order displayed and comment below retun 
  //https://infinitylearn.atlassian.net/browse/IUF-9328
  
  return { 
    // subjects:examInfo?.subjectsdata
    subjects: Object.keys(subjectsByName)?.map(v=>{
    return {
    "name": subjectsByName[v]?.name?.toUpperCase(),
    "displayedName":subjectsByName[v]?.displayedName?.toUpperCase(),
    "position": 0
    }
    }), subjectsByName };

}


export function timeConvert(n:number) {
  var num = n;
  var hours = (num / 3600);
  var rhours = Math.floor(hours);
  var minutes = (hours - rhours) * 60;
  var rminutes = Math.round(minutes);
  return  rhours + "h " + rminutes + "m";
}
export function getSecondsinHours(totalVisitedTime){
  let testdate: any = new Date(null);
    testdate.setSeconds(totalVisitedTime);
    testdate = testdate.toISOString().substr(11, 8);
    return `${testdate.substring(0,testdate.indexOf(':'),)}h ${testdate.substring(testdate.indexOf(':') + 1,testdate.lastIndexOf(':'),)}m ${testdate.substring(testdate.lastIndexOf(':') + 1, testdate.length)}s`
}
export function getDateFromTestSpan(s: string) {
  const execResult = testSpanFormat.exec(s);
  if(!execResult) {
    let serverTime = localStorage.getItem('serverTime');
    let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");
    return new Date(current_time);
  } else {
    const y: any = execResult[1];
    const m: any = execResult[2];
    const d: any = execResult[3];
    let h: any = Number(execResult[4]) || 0;
    const mins: any = execResult[5];
    let meridiem = execResult[6];
    if(meridiem.toLocaleLowerCase() == "pm" && h != 12) {
      h = Number(h) + 12;
    } else if(meridiem.toLocaleLowerCase() == "am" && h == 12) {
      h = 0;
    }
    return new Date(y, m - 1, d, h, mins)
  }
}
export function setLoggedInUserData(data, userService, authService) {
  localStorage.setItem('token', data.accessToken)
  localStorage.setItem('studentid', data.userDto.phone)
        let gradeByName = data?.userDto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', '');
        userService.setMobileAndName({
          phone: data.userDto.phone, isdCode: data.userDto.isdCode, firstName: data.userDto.firstName, lastName: data.userDto.lastName,
          whatsappConsent: data.userDto.whatsappConsent, userId: data.userDto.userId, profilePhoto: data.userDto.profilePhoto, grade: Number(gradeByName)
        });
        userService.setUserTypes(data.userDto.userType);
        userService.updateRequestedUserData(data.userDto);
        authService.updateAuthStatus(true);
        userService.setUserRoles(data.userDto.roles);
      if(data?.userDto?.userId){
        let Window  :any= window 
        Window?.heap?.identify(data?.userDto?.userId)
      }
      
}
export function gotoList(e: any,infobox) {
  e.preventDefault();
  e.stopPropagation();
  if(infobox.examtype == "ILTS" || infobox.examtype == "TIMEBOUND" || infobox.examtype == "New NEET Timebound") {
    const key = infobox.examtype == "New NEET Timebound" ? "_new_pattern": "";
    const testType = this.tenant=='srichaitanya' ? ("SCTS"+key): ("ILTS"+key);
    this.gaService.sendEvent(
      `${testType}_OPEN_LIST`, 
      `${testType}_dashboard`, 
      `${testType}_OPEN_LIST`, 
      'open_list',  
    );
  }
  this.router.navigateByUrl(infobox.link.route);
 } 

 export function getTimeDetails(time_in_seconds: any) {
  time_in_seconds = parseInt(time_in_seconds);
  if (time_in_seconds > 0) {
    let time_details = new Date(time_in_seconds * 1000).toISOString().substr(11, 8);
    var time_details_array = time_details.split(":");
    if (time_details_array[0] != '00') {

      let hour = (parseInt(time_details_array[0]) >= 10) ? time_details_array[0] : time_details_array[0].substring(1, 2);
      let min  = (parseInt(time_details_array[1]) >= 10) ? time_details_array[1] : time_details_array[1].substring(1, 2);
      return hour + "h " + min + "m";

    } else {

      let min  = (parseInt(time_details_array[1]) >= 10) ? time_details_array[1] : time_details_array[1].substring(1, 2);
      let sec = (parseInt(time_details_array[2]) >= 10) ? time_details_array[2] : time_details_array[2].substring(1, 2);
      return min + "m " + sec + "s";
    }

  } else {
    return '0m 0s';
  }
}

 export function isCurrentTimeGreaterExamEndtime(test: any, nowVal: any) {
  let string =test?.span;
  let examstart = getDateFromTestSpan(string);
  let examendDateTime = new Date(+examstart).setMinutes(examstart.getMinutes() + parseInt(test?.duration));
  let serverTime = localStorage.getItem('serverTime')+'000';
  let serverTimeNow = Number(serverTime);
  return (nowVal ||serverTimeNow) > examendDateTime;
}

export function getChapterOrTopicObject(itemsObj: any, itemId: any, allItems: any, itemIdentifier: any) {
  if(!itemsObj[itemId]) {
    itemsObj[itemId] = {
      [itemIdentifier]: itemId,
      [itemIdentifier + 'Name']:getChapterOrTopicNameByCode(itemId, allItems, itemIdentifier),
      totalQuestions: 0,
      totalAttemptedQuestions: 0,
      totalUnattempted: 0,
      correctQuetions: 0,
      incorrectQuetions: 0,
      totalVisitedTime: 0,
      totalVisitedTimeForAttemptedQuestions:0,
      totalScore: 0,
      accuracy: 0,
      avgTime: 0,
      avgTimeForAttemptedQuestion:0
    }
  }
  return itemsObj[itemId];
}

export function getChapterOrTopicNameByCode(itemCode: any, allItems: any, itemIdentifier: any) {
  if (itemCode) {
      let item = allItems.find((Item: any)=>{
        return Item[itemIdentifier + 'code'] == itemCode;
      });
      if (item) {
        return item[itemIdentifier+'name'];
      } else {
        return itemCode;
      }
  } else {
    return 'NA';
  }
  
}
/*Calculate difference between examtime and servtime and return in milli seconds*/
export function timeDifferencetestTimeandserver(test){
  let servertime =  moment.unix(+localStorage.getItem('serverTime'))
  let attemptime = moment(test.span,"YYYY-MM-DD hh:mm A").subtract(10, "minutes")//subsract 10 min from examtime 
  let timedifference_ms= attemptime.diff(servertime,'milliseconds',true);
  // let timedifference_min= attemptime.diff(servertime,'minutes',true);
    return timedifference_ms;
  }

export function getSubIcon(sub: string) {
    let modSub = sub?.split(' ')[0].toLowerCase();
      switch (modSub) {
        case 'quant.':
        case 'quantitative':
        case 'quantitativereasoning':
        case 'mathematics':
        case 'maths':
        case 'math':
          return 'Maths';
          break;
        case 'chemistry':
        case 'chem':
          return 'Chemistry';
          break;
        case 'biol':
        case 'biology':
          return 'Biology';
        case 'zool':
        case 'zoology':
          return 'Zoology'
        case 'botany':
        case 'bota':
          return 'Botany'
        case 'physics':
        case 'phy':
          return 'Physics';
          break;
        case 'science':
        case 'spatial':
        case 'spatialreasoning':
          return 'Science';
          break;
        // case 'english':
        case 'verbal':
        case 'verbalreasoning':
        case'criticalthinking':
        case "critical":
        return 'Criticalthinking';
        break;
        case 'logicalreasoning':
        case 'logical':
        return 'Logicalreasoning'
        case 'problemsolving':
         case 'problem':
        return 'Problemsolving';
          break;
        case 'generaltest':
        case 'general':
        return 'General Test';
        break;
        case 'english':
        return 'english';
        break;
        case 'mentalability':
          case 'mental':
          return 'mentalability';
          break;
        default:
          return modSub?.charAt(0)?.toUpperCase()+modSub?.slice(1);
          break;
      }
  }

  export function getILCookie(name: string) {
    const ca: Array<string> = decodeURIComponent(document.cookie).split(';');
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;
  
    for (let i = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
  
  export function setILCookie(name: string, value: string, expireDays: number, path: string = '') {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    const cpath = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; domain=${environment.Domain}; ${expires}${cpath}; SameSite=Lax`;
  }

  export function checkCBSEGr8() {
    let targetExam = localStorage.getItem('targetExamName');
    let selectedGrade = JSON.parse(localStorage.getItem('user_details_from_server'));
    if (targetExam === 'CBSE' && cbseScienceGrade.indexOf(selectedGrade?.grade?.name?.replace('th', '')) > -1) {
      return true;
    }
  }

  export function clearLocalStorage(){
    const isFromShareLink : boolean = (localStorage.getItem('isFromShareLink') == 'true') ? true : false;
    const ruleId = localStorage.getItem('ruleIdFromShare');
    const isFromExternalApp : boolean = (localStorage.getItem('isFromExternalApp') == 'true') ? true : false;
    const pageName = localStorage.getItem('pageName');
    localStorage.clear();
    setSharingData(isFromShareLink, ruleId, isFromExternalApp, pageName);
  }

  export function setSharingData(isFromShareLink, ruleId, isFromExternalApp, pageName){
    checkForCyotShare(isFromShareLink, ruleId);
    checkForIsNAvigatedExternalApp(isFromExternalApp, pageName);
  }

  export function checkForCyotShare(isFromShareLink, ruleId){
    if(isFromShareLink == true) {
      localStorage.setItem('isFromShareLink', 'true');
      localStorage.setItem('ruleIdFromShare',ruleId);
    }
  }

  export function checkForIsNAvigatedExternalApp(isFromExternalApp, pageName){
    if(isFromExternalApp == true) {
      localStorage.setItem('isFromExternalApp', 'true');
      localStorage.setItem('pageName',pageName);
    } 
  }

  export function clearExamMetaData(){
    let exam_meta_data: any = localStorage.getItem('exam_meta_data');
    if (exam_meta_data) {
      localStorage.removeItem('exam_meta_data');
    }
  }
  export function checkIfNonScienceSubjectExists(subjects){
    let isNonScienceSubjectExists:boolean = false;
    subjects.forEach(subject => {
      if(subjects.length == 1 && subject == 'Maths') isNonScienceSubjectExists =  true;    
    });
    return isNonScienceSubjectExists;
  }
  export function filterCMSData() {
    // let exam = JSON.parse(localStorage.getItem("selectedExam"));
    const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
    const examId = details.find(e => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId;
    let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    let cmsDetails = environment.UAM_TO_CMS_CONVERSION?.filter(ele => (examId === ele?.UAM_exam_id) && user?.grade?.gradeId === ele?.UAM_grade_id);
    return cmsDetails;
  }

  export function getExamName(examId) {
    const value = (examId?.value) ? examId?.value : examId;
    var examname = testTypeValues.filter(testTypeItem => testTypeItem.value == value);
    return (examname.length > 0) ? examname[0].name : '';
  }

  export function getCourseName(examId) {
    var coursename =  courseTypes.exams.filter(courseItem => courseItem.examId == examId);
    return (coursename.length > 0) ? coursename[0].name : '';
  }

  export function getCourseId(examName) {
    var course =  courseTypes.exams.filter(courseItem => courseItem.name == examName);
    return course[0].examId.toString();
  }

  export function getIpAddress() {
    return fetch("https://api.ipify.org/?format=json")
      .then((res) => res.json())
      .then((res: any) => {
        localStorage.setItem("deviceIp", res?.ip);
      })
  }
  export function getCMSIDExamName(examname) {
    let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    let cmsDetails = environment.UAM_TO_CMS_CONVERSION?.find((ele:any) => (examname?.replaceAll(' ', '')?.toUpperCase() === ele?.UAM_Exam_Name?.replaceAll(' ', '')?.toUpperCase()) && user?.grade?.gradeId === ele?.UAM_grade_id);
    return cmsDetails;
  }

  export async function isUserAdmin(userService) {
    let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    let user_roles = userService.getUserRoles();
    let isAdmin : boolean = false;
    let isGradeMapped : boolean = false;
    user_roles.forEach(role => {
      if(role.roleName == Admin) {isAdmin = true}
    });
    const data: any = await userService.getUsergrades(user?.userId).toPromise();
    let grades = data.Grades[0];
    grades?.forEach(element => {
      if(element.gradeId == user.grade.gradeId && isAdmin) {isGradeMapped = true;}
    });
    console.log(isAdmin, isGradeMapped)
    return (isAdmin && isGradeMapped) ? true : false;
  }
  export function totalTimeTakebySchdule(allschdules){
      let startExam = allschdules.slice(0,1)?.[0]
      let Endexam = allschdules.slice(-1)?.[0]
      let starttime =startExam?.span? moment(startExam?.span, 'YYYY-MM-DD HH:mm A').format('Do MMM YYYY  (hh:mm A '):'';
      let endtime = Endexam?.span? moment(Endexam?.span, 'YYYY-MM-DD HH:mm A').add(parseInt(Endexam?.duration), 'minutes').format('- hh:mm A)'):'';
      return starttime+endtime
  }

  export function getISDName(countryCode:string) {
    ISDCodes.forEach(element => {
       if(element.countryCode == countryCode) return element.countryName
    });
  }

  export function getISDCode(countryName:string) {
    ISDCodes.forEach(element => {
       if(element.countryName == countryName) return element.countryCode
    });
  }
  export function getMomentUTCtime(){
    return moment.utc()?.valueOf()?.toString()?.slice(0,-3)
  }






